import { defineComponent as _defineComponent } from 'vue'
import InvoicesActionContractSelector from '@/views/my-projects/components/invoices/action-box/InvoicesActionContractSelector.vue';
import InvoicesActionContractDetails from '@/views/my-projects/components/invoices/action-box/InvoicesActionContractDetails.vue';
import { ref } from 'vue';
import useMessengerState from '@/state/messenger/messengerState';
import { useAsyncState } from '@vueuse/core';
import { getAllContracts } from '@/services/ContractService';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicesNewInvoiceAction',
  setup(__props) {

const selectedContract = ref(null);

const { isOpened: isMessengerOpened } = useMessengerState();

const onSelect = (contract: any) => {
  selectedContract.value = contract;
  isMessengerOpened.value = false;
};

const { state: contractData } = useAsyncState(() => getAllContracts(), []);


return { __sfc: true,selectedContract, isMessengerOpened, onSelect, contractData, InvoicesActionContractSelector, InvoicesActionContractDetails }
}

})